// extracted by mini-css-extract-plugin
export default {"controls":"Lightbox_controls__JtIU+"};